<template>

      <FlashNotifications ref="flash" />
        <div class="h-[57vh] mt-2 overflow-y-auto pl-7 pr-4 scrollbar-style">
                  <div class="">
                    <div class="flex">
                        <div class="flex w-10">
                            <div class="mt-4">
                                <svg class="w-4 h-4 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="relative rounded bg-gray-100 hover:bg-gray-200 text-sm w-full dark:bg-gray-700 dark:hover:bg-slate-800 dark:border-gray-500 dark:text-gray-200 ">
                              <button @click="toggleEventsDropdown" class="flex w-full min-h-[50px]  px-3 text-left items-center">
                                  <span v-if="temp_event.name === null || temp_event.name === undefined || temp_event.name === '' ">Select an event</span>
                                  <span v-else class="flex items-center" >
                                    {{ temp_event.name }}
                                  </span>
                              </button>
                              <span @click="toggleEventsDropdown">
                                <svg :class="{ 'rotate-180' : eventsdropdownOpen}"  class="absolute right-3 top-4 cursor-pointer w-5 h-5 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"></path></svg>
                              </span>          
                                     
                              <span>
                                 <div v-if="eventsdropdownOpen" @click="toggleEventsDropdown" class="click fixed inset-0"></div>
                                  <div v-if="eventsdropdownOpen" class="absolute z-20 left-0 w-full rounded overflow-hidden" style="box-shadow:0 3px 5px 1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);">
                                      <div  class="g-form relative flex shrink-0 items-center rounded-t bg-white border-b pl-2.5 dark:bg-gray-600">
                                            <div class="shrink-0 text-gray-400 dark:text-gray-300" role="none">
                                              <svg class="w-5 h-5 fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"></path></svg>
                                            </div>
                                          <input
                                              ref="searchInput" 
                                              type="text"
                                              v-model="searchQuery"
                                              class="text-sm w-full rounded-t focus:ring-transparent dark:bg-gray-600 border-none dark:text-gray-200"
                                              :placeholder="I18N.application.attendees.search_placeholder"
                                            />
                                          <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                                      </div>
                                      <ul class="left-0 rounded-b w-full overflow-y-auto max-h-60 scrollbar-style z-20 bg-white dark:bg-gray-600 border dark:border-gray-500 dark:text-gray-200" >
                                        <li v-for="event in filteredEvents" :key="event.id">
                                            <button v-on:click="selectValue(event)" 
                                                :class="{
                                                            'bg-blue-100 dark:bg-blue-300': event.id === selected_event?.id,
                                                            'hover:bg-gray-100 dark:hover:bg-gray-500': event.id !== selected_event?.id
                                                          }"
                                                class="hover:bg-gray-100 dark:hover:bg-gray-500 w-full flex items-center text-left py-2 px-4">
                                              <span :class="event.color" class="w-4 h-4 -ml-1 mr-2 rounded-full"></span>
                                              {{ event.name }}
                                              <span v-if="event.slot_duration" class="ml-auto text-[13px] "> 
                                                    {{ event.slot_duration }}
                                              </span>
                                            </button>
                                        </li>
                                      </ul>
                                  </div>
                              </span>
                            </div>
                            <div
                              class="g-form border-b border-gray-500 text-gray-700 mt-2 relative dark:text-gray-300 dark:hover:text-gray-100"
                            >
                              <input
                                v-model="selected_event.name"
                                class="bg-transparent border-none text-2xl w-full py-1 focus:ring-transparent"
                                placeholder="Add title"
                                type="text"
                                autocomplete="off"
                              />
                              <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="flex mt-7">
                        <div class="flex w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path><path d="M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex items-center ">
                                <div>
                                    <v-date-picker v-model="target_date" 
                                        :popover="{ visibility: 'focus' }" 
                                        mode="date"
                                        :locale="CURRENT_LOCALE"
                                        :is-dark="isDark" 
                                    >
                                        <template #default="{ inputValue, inputEvents }">
                                            <div class="flex gap-4 w-full">
                                                <div>
                                                    <div class="g-form relative">
                                                        <input 
                                                            id="filter-date-range" 
                                                            ref="filterDateRange" 
                                                            type="text" 
                                                            name="range" 
                                                            class="hover:bg-gray-100 border-none border-gray-50 text-gray-900 w-48 text-sm rounded ring-0 appearance-none focus:ring-transparent block px-1 py-2.5 dark:bg-gray-700 dark:border-gray-500 dark:text-gray-400 dark:placeholder-gray-400 date-gray-400" 
                                                            :value="formattedDate" 
                                                            v-on="inputEvents" 
                                                            autocomplete="off"
                                                        >
                                                        <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </v-date-picker>
                                </div>
                                <div class="ml-2">
                                    <div class="flex items-center w-full">
                                        <CustomSlotsDropdown
                                          name="start"
                                          :selected_value="target_time.start"
                                          :values="generateStartTimeSlots()"
                                          @change="updateSlotDropdownValue"
                                        >
                                        </CustomSlotsDropdown>

                                        
                                        <p class="px-1 pb-1 dark:text-gray-400">-</p>
                                        <CustomSlotsDropdown
                                          name="end"
                                          :selected_value="target_time.end"
                                          :values="generateEndTimeSlots()"
                                          @change="updateSlotDropdownValue"
                                        >
                                        </CustomSlotsDropdown>
                                        
                                    </div>
                                </div>
                            </div>
                            <p v-if="checkDuration" class="text-xs text-red-500">{{ slot_error }}</p>
                        </div>
                  </div>
                  <div class="flex my-5">
                        <div class="flex w-10">
                            <div class="mt-2">
                                <svg class="w-5 h-5 fill-gray-500" viewBox="0 0 24 24"><path d="M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4c-.43 0-.84-.09-1.23-.21-.03-.01-.06-.02-.1-.03A5.98 5.98 0 0 0 15 8zm1.66 5.13C18.03 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.58-3.47-6.34-3.87zM9 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 9c-2.7 0-5.8 1.29-6 2.01V18h12v-1c-.2-.71-3.3-2-6-2M9 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 9c2.67 0 8 1.34 8 4v3H1v-3c0-2.66 5.33-4 8-4z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <SearchContactsDropdown @change="updateAttendeeEmail"></SearchContactsDropdown>
                        </div>
                  </div>
                  <div class="flex my-5">
                        <div class="flex w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-500"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m12 22 1-2v-3h5a1 1 0 0 0 1-1v-1.586c0-.526-.214-1.042-.586-1.414L17 11.586V8a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3a1 1 0 0 0 1 1v3.586L5.586 13A2.01 2.01 0 0 0 5 14.414V16a1 1 0 0 0 1 1h5v3l1 2zM8 4h8v2H8V4zM7 14.414l1.707-1.707A.996.996 0 0 0 9 12V8h6v4c0 .266.105.52.293.707L17 14.414V15H7v-.586z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div
                              class="g-form text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 rounded hover:cursor-pointer relative dark:text-gray-300 dark:hover:text-gray-100"
                            >
                              <input
                                v-model="selected_event.location_name"
                                class="bg-transparent w-full focus:bg-gray-100 border-none rounded focus:border-b focus:border-blue-500 py-1 focus:ring-transparent dark:hover:bg-gray-700 dark:focus:bg-gray-700 dark:text-gray-400"
                                placeholder="Add Location"
                                type="text"
                                :disabled="temp_event.location_name != undefined"
                                autocomplete="off"
                              />
                              <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                  </div>
                  <div class="flex my-5">
                        <div class="flex w-10">
                            <div class="mt-2.5 ml-1">
                                <svg class="fill-gray-500" xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div
                              class="relative g-form text-gray-700 rounded hover:cursor-pointer relative dark:text-gray-300 dark:hover:text-gray-100"
                            >   
                                <button v-if="descriptionHidden" @click="toggleDescriptionHidden" class="w-full text-start px-3 py-1 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-400 text-gray-500 rounded">Add Description</button>
                                <textarea v-if="!descriptionHidden"
                                          ref="descriptionTextarea" 
                                          type="text" 
                                          v-model="booking_details.description"
                                          @focus="handleTextareaFocus"
                                          @blur="handleTextareaBlur"
                                          class="w-full border-none rounded bg-gray-100 focus:ring-transparent dark:bg-gray-700" rows="3"></textarea>
                                <div v-if="!descriptionHidden" class="before-absolute bg-blue-600 -mt-2 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
                            </div>
                        </div>
                  </div>
                  <div class="flex items-center mt-3">
                        <div class="flex w-10">
                            <div class="">
                                <svg class="w-5 h-5 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11 12h6v6h-6z"></path><path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            
                            <div class="flex items-center">
                                <div :class="selected_event.color" class="w-4 h-4 rounded-full ml-2"></div>
                                <p v-if="selected_event.connected_calendar_email != null" class="text-sm text-gray-600 pl-3">
                                    {{ selected_event.connected_calendar_email }}
                                </p>
                                <span v-else>
                                    <p v-if="selected_event.connected_calendar_email == null && selected_event.name != ''" class="text-sm text-gray-600 pl-3">
                                         
                                        <a :href="'/events/' + selected_event.id + '/edit'" class="underline">Edit event</a>
                                        to select a calendar
                                    </p>
                                    <p v-else class="text-sm text-gray-600 pl-3">
                                        Select an event to see Calendar
                                    </p>
                                </span>
                            </div>
                        </div>
                  </div>
        </div>  
        <div class="flex justify-end px-5 py-2">
            <div class="flex items-center">
                 <button @click="SubmitBookingForm" 
                         :class="{ 'pointer-events-none opacity-50' : slot_error != '' || attendees.length === 0 || Object.keys(this.temp_event).length === 0 }" 
                         class="bg-blue-600 rounded px-7 py-[9px] text-sm text-white focus:outline-none focus-visible:outline-2 hover:text-slate-100 hover:bg-blue-500 inline-flex items-center justify-center">
                      Save
                 </button>
            </div>
        </div>          
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
import RequestMixin from "controllers/vue_components/mixins/request"
import FlashNotifications from "controllers/vue_components/flash_toast"
import SearchContactsDropdown from "controllers/vue_components/fields/search_contacts_dropdown";
import CustomSlotsDropdown from "controllers/vue_components/fields/custom_dropdown_slots";
import { useCalendarStore } from 'controllers/vue_components/calendar/store'

export default {
    name: 'InternalBookingForm',
    props: ['new_data'],
    emits: ['booking-success'],
    mixins: [Constants, RequestMixin],
    components:{
        SearchContactsDropdown, FlashNotifications, CustomSlotsDropdown
    },
    data() {
        return {
            data:{},
            events_list : [],
            temp_event : {},
            slot_error: '',
            selected_event : {
                name:"",
                color:"peacock",
                location_name: "",
                connected_calendar_email: null
            },
            attendees: [],
            booking_details: {
                ignore_slot_validation: true,
                name: '',
                event_id: null,
                description: '',
                start_at: null,
                end_at:null,
            },
            isTitleInputFocused: false,
            datePickerKey: 0,
            target_date: new Date(),
            target_time:{
                start: null,
                end: null,
            },
            eventsdropdownOpen: false,
            searchQuery: '',
            descriptionHidden: true,
            calendar_settings: [],
            isDark: document.documentElement.classList.contains('dark'),
        };

    },
    methods: {
        async SubmitBookingForm(){
            if(Object.keys(this.temp_event).length === 0){
                this.$refs.flash.show("Select an event for booking", 'alert');
            }
            else if(this.attendees.length === 0){
                this.$refs.flash.show("Guest cant not be blank", 'alert');
            }
            else {
                let data_set = {
                    attendees: this.attendees,
                    booking: this.booking_details,
                }
                let resp = await this.axiosRequest('POST', '/api/v1/calendar/internal_bookings', data_set, false)
                if (resp.js_error == false && resp.response.success) {
                    this.$emit('booking-success');
                } else {
                    this.$refs.flash.show(resp.error.data.message, 'alert');
                }
            }
        },
        updateBookingDetailsName(newName) {
            this.booking_details.name = newName;
        },
        useCalendarStoreObj() {
            return useCalendarStore();
        },
        getCalendarSettings() {
            return this.useCalendarStoreObj().calendar_settings;
        },
        toggleEventsDropdown() {
            this.eventsdropdownOpen = !this.eventsdropdownOpen;
            this.searchQuery = '';

        },
        selectValue(event) {
            this.booking_details.event_id = event.id;
            this.booking_details.name = event.name;
            this.temp_event = event;
            this.selected_event = { ...event };
            this.eventsdropdownOpen = false;
        },
        updateEventData(data) {
            this.data = data;
            this.target_date = new Date(data.start)
            const startHours = this.target_date.getHours();
            const startMinutes = this.target_date.getMinutes();
            this.target_time.start = this.calendar_settings.time_format === '12_hours'
                ? this.formatTime12Hours(`${startHours}:${startMinutes}`)
                : `${startHours < 10 ? '0' : ''}${startHours}:${startMinutes < 10 ? '0' : ''}${startMinutes}`;

            const endTime = new Date(data.end);
            const endHours = endTime.getHours();
            const endMinutes = endTime.getMinutes();
            this.target_time.end = this.calendar_settings.time_format === '12_hours'
                ? this.formatTime12Hours(`${endHours}:${endMinutes}`)
                : `${endHours < 10 ? '0' : ''}${endHours}:${endMinutes < 10 ? '0' : ''}${endMinutes}`;

        },
        toggleDescriptionHidden() {
            this.descriptionHidden = !this.descriptionHidden;
            if (!this.descriptionHidden) {
                this.$nextTick(() => {
                    this.$refs.descriptionTextarea.focus();
                });
            }
        },
        handleTextareaFocus() {
            this.descriptionHidden = false;
        },
        handleTextareaBlur() {
            if (this.booking_details.description.trim() === '') {
                this.descriptionHidden = true;
            }
        },
        updateSlotDropdownValue(value){
            let attr = Object.keys(value)[0];
            this.target_time[attr] = value[attr];

            if (attr === 'start' || attr === 'end') {
                this.calculateEndTime(); // Update end time based on start time
                this.checkDuration(); // Check and update duration
            }
        },
        updateAttendeeEmail(value) {
            this.attendees = value;
        },
        generateStartTimeSlots() {
            const timeSlots = [];
            for (let hours = 0; hours < 24; hours++) {
                for (let minutes = 0; minutes < 60; minutes += 15) {
                    if (!(hours === 23 && minutes === 45)) {
                        const formattedHours = String(hours).padStart(2, '0');
                        const formattedMinutes = String(minutes).padStart(2, '0');
                        const time = `${formattedHours}:${formattedMinutes}`;
                        timeSlots.push(time);
                    }
                }
            }
            return this.calendar_settings.time_format === '12_hours'
                ? timeSlots.map(time => this.formatTime12Hours(time))
                : timeSlots;
        },
        generateEndTimeSlots() {
            const timeSlots = [];
            const is12HourFormat = this.calendar_settings.time_format === '12_hours';

            // Parse the start time safely using Date to handle 12-hour AM/PM edge cases
            const parsed = new Date('2000-01-01 ' + this.target_time.start);
            const startHour = parsed.getHours();
            const startMinute = parsed.getMinutes();

            for (let hours = startHour; hours < 24; hours++) {
                for (let minutes = 0; minutes < 60; minutes += 15) {
                    if (hours > startHour || (hours === startHour && minutes > startMinute)) {
                        const formattedHours = String(hours).padStart(2, '0');
                        const formattedMinutes = String(minutes).padStart(2, '0');
                        timeSlots.push(`${formattedHours}:${formattedMinutes}`);
                    }
                }
            }

            return is12HourFormat
                ? timeSlots.map(time => this.formatTime12Hours(time))
                : timeSlots;
        },

        formatDateTime(date, time) {
            const formattedDate = new Date(date);

            // Validate the date
            if (isNaN(formattedDate.getTime())) {
                console.error('Invalid date:', date);
                return null;  // Or you can return a default value or throw an error
            }

            const [hours, minutes] = time.split(':');

            // Validate the time components
            const validHours = parseInt(hours, 10);
            const validMinutes = parseInt(minutes, 10);

            if (isNaN(validHours) || isNaN(validMinutes) || validHours < 0 || validHours >= 24 || validMinutes < 0 || validMinutes >= 60) {
                console.error('Invalid time:', time);
                return null;  // Or you can return a default value or throw an error
            }

            formattedDate.setHours(validHours, validMinutes, 0, 0);

            // Validate the resulting date after setting time components
            if (isNaN(formattedDate.getTime())) {
                console.error('Invalid date after setting time components:', date, time);
                return null;  // Or you can return a default value or throw an error
            }

            return formattedDate.toISOString();
        },


        calculateEndTime() {
            if (this.selected_event.slot_duration) {
                let slotDurationInMinutes = 0;
                let temp = this.target_time.end;

                if (this.selected_event.slot_duration.includes('H')) {
                    slotDurationInMinutes = parseInt(this.selected_event.slot_duration) * 60;
                } else {
                    slotDurationInMinutes = parseInt(this.selected_event.slot_duration, 10);
                }

                const startTime = new Date(this.target_date);
                const endTime = new Date(startTime.getTime() + slotDurationInMinutes * 60000);

                const endHours = endTime.getHours();
                const endMinutes = endTime.getMinutes();

                temp = this.calendar_settings.time_format === '12_hours'
                    ? this.formatTime12Hours(`${endHours}:${endMinutes}`)
                    : `${endHours < 10 ? '0' : ''}${endHours}:${endMinutes < 10 ? '0' : ''}${endMinutes}`;

                if (temp !== this.target_time.end) {
                    this.slot_error = 'You can book an event only within the event slot duration';
                }

                // Update booking details
                this.booking_details.start_at = this.formatDateTime(this.target_date, this.target_time.start);
                this.booking_details.end_at = this.formatDateTime(this.target_date, this.target_time.end);
            }
        },

        checkDuration() {
            if (this.selected_event.slot_duration) {
                const start = new Date(this.target_date);
                const end = new Date(this.target_date);

                const [startHours, startMinutes] = this.target_time.start.split(':');
                const [endHours, endMinutes] = this.target_time.end.split(':');

                const isStartPM = /PM/i.test(this.target_time.start);
                const isEndPM = /PM/i.test(this.target_time.end);

                start.setHours(parseInt(startHours, 10) + (isStartPM ? 12 : 0), parseInt(startMinutes, 10));
                end.setHours(parseInt(endHours, 10) + (isEndPM ? 12 : 0), parseInt(endMinutes, 10));

                const durationInMinutes = parseInt(this.selected_event.slot_duration, 10);

                const timeDifference = (end - start) / (60 * 1000); // Difference in minutes

                if (timeDifference !== durationInMinutes) {
                    this.slot_error = 'Time difference does not match slot duration';
                    return false;
                }
            }

            this.slot_error = '';
            return true;
        },



        formatTime12Hours(time) {
            const [hours, minutes] = time.split(':');
            const formattedHours = (hours % 12) || 12;
            const formattedMinutes = minutes.padStart(2, '0');
            const amPm = hours >= 12 ? 'PM' : 'AM';
            return `${formattedHours}:${formattedMinutes} ${amPm}`;
        }

    },
    watch: {
        'target_date': 'calculateEndTime',
        'selected_event.slot_duration': 'calculateEndTime',
        'selected_event.name': 'updateBookingDetailsName',
        'target_time.start': 'checkDuration',
        'target_time.end': 'checkDuration',
    },
    computed: {
        formattedDate() {
            const options = { weekday: 'long', month: 'long', day: 'numeric' };
            return this.target_date.toLocaleDateString('en-US', options);
        },
        filteredEvents() {
            const query = this.searchQuery.toLowerCase();
            const filteredevents = this.events_list.filter((event) => {
                return (
                    event.name.toLowerCase().includes(query)
                );
            });

            filteredevents.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });

            return filteredevents;
        },
    },
    async created() {
        this.calendar_settings = this.getCalendarSettings();
        if (this.new_data) {
            this.updateEventData(this.new_data);
        }
        this.events_list = useCalendarStore().host_events;
    }
};
</script>
